/* eslint-disable no-undef */
import * as VTable from '@visactor/vtable'

// 引入input框等
import { InputEditor } from '@visactor/vtable-editors'
const {
  default: NumberEditor,
  PointEditor
} = require('./VTableConfig')

// 注册必须的组件
// const NumberEditor = NumberEditor
VTable.register.editor(`inpnutEdit`, new InputEditor())
VTable.register.editor(`numberEditor`, new NumberEditor())
VTable.register.editor(`pointEditor`, new PointEditor())

// 导出
export default VTable
